import React, { useEffect, useState } from "react";
import "./Converter.scss";

const Converter = ({ currencies, coins }) => {
  // Set initial state to empty strings or a fallback value.
  const [fromCurrency, setFromCurrency] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [amount, setAmount] = useState("");
  const [convertedAmount, setConvertedAmount] = useState("۰");

  useEffect(() => {
    // Ensure currencies are loaded before setting the initial state
    if (currencies && currencies.length > 0) {
      setFromCurrency(currencies[0]?.currency.name || "");
      setToCurrency(currencies[1]?.currency.name || "");
    }
  }, [currencies]); // Depend on currencies to update when it changes

  const handleConvert = () => {
    if (!amount || isNaN(amount)) {
      // Handle invalid input (e.g., non-numeric input)
      setConvertedAmount("مبلغ مورد نظر را وارد کنید");
      return;
    }

    // Find the selected currencies' sell prices
    const fromCurrencyData = currencies.find(
      (currency) => currency.currency.name === fromCurrency
    );
    const toCurrencyData = currencies.find(
      (currency) => currency.currency.name === toCurrency
    );

    if (!fromCurrencyData || !toCurrencyData) {
      // Handle case where currencies are not found
      setConvertedAmount("ارز مورد نظر را انتخاب کنید");
      return;
    }

    const fromPrice = fromCurrencyData.sellPrice;
    const toPrice = toCurrencyData.sellPrice;

    if (!fromPrice || !toPrice) {
      // Handle case where sellPrice is not available
      setConvertedAmount("Price data unavailable");
      return;
    }

    // Convert the amount to the target currency
    const convertedValue = (amount * fromPrice) / toPrice;

    // Format the result as Persian currency with commas
    const formattedAmount =
      convertedValue.toLocaleString("fa-IR") + " " + toCurrency;

    setConvertedAmount(formattedAmount);
  };

  return (
    <div className="converter-container wide-page-margin-2">
      <div className="converter-box bg-[#F5F6FA] rounded-[1.125rem] px-[3.44rem] py-[2.75rem] w-[80%]">
        <div className="converter">
          <input
            type="text"
            placeholder="۰"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />

          <select
            value={fromCurrency}
            onChange={(e) => setFromCurrency(e.target.value)}
          >
            {currencies?.map((currency, index) => (
              <option key={index} value={currency.currency.name}>
                {currency.currency.name}
              </option>
            ))}
          </select>

          <select
            value={toCurrency}
            onChange={(e) => setToCurrency(e.target.value)}
          >
            {currencies?.map((currency, index) => (
              <option key={index} value={currency.currency.name}>
                {currency.currency.name}
              </option>
            ))}
          </select>

          <button
            className="gradient-btn-1 w-[100%] flex justify-center items-center"
            onClick={handleConvert}
          >
            تبدیل
          </button>

          <div className="result">{convertedAmount}</div>
        </div>
      </div>
      <div className="content">
        <div className="title">تبدیل واحد پول کشورها به یکدیگر</div>
        <div className="desc">
          تبدیل واحدهای پولی کشورهای مختلف به یکدیگر یکی از اساسی‌ترین نیازها در
          تجارت جهانی، سفرهای بین‌المللی و مبادلات مالی است. با استفاده از
          نرخ‌های لحظه‌ای ارز و ابزارهای آنلاین، می‌توان به‌سادگی ارزش پول یک
          کشور را نسبت به دیگری محاسبه کرد.
        </div>
      </div>
    </div>
  );
};

export default Converter;
